function Heading({ level, className, id, children }) {
  const HeadingTag = `h${level}`;
  return (
    <HeadingTag className={className} id={id}>
      {children}
    </HeadingTag>
  );
}

export default function ApplicationSectionHeader({
  title,
  titleId,
  headingLevel = 2,
  variant = 'default',
  contextLabel,
  description,
  actions,
  className = '',
}) {
  if (!['default', 'compact'].includes(variant)) {
    throw new Error(
      `Unsupported ApplicationSectionHeader variant: ${variant}`
    );
  }

  const classes = [
    'av-app-section-header',
    `av-app-section-header--${variant}`,
    className,
  ].filter(Boolean).join(' ');

  return (
    <header className={classes}>
      <div className="av-app-section-header__copy">
        {contextLabel && (
          <p className="av-app-section-header__context">
            {contextLabel}
          </p>
        )}

        <Heading
          className="av-app-section-header__title"
          id={titleId}
          level={headingLevel}
        >
          {title}
        </Heading>

        {description && (
          <p className="av-app-section-header__description">
            {description}
          </p>
        )}
      </div>

      {actions && (
        <div className="av-app-section-header__actions">
          {actions}
        </div>
      )}
    </header>
  );
}
